import { Axios } from "../axios";
import { getAuthData } from "../../pages/remittance-beta/api/remittanceApi";
import {
  DigioSignCompletePayload,
  DigioUploadPayload,
  K2DigioRecord,
} from "../../pages/remittance-beta/types/digio/K2Digio";

const getHeaders = () => {
  const { token } = getAuthData();
  return {
    Authorization: token,
    "Content-Type": "application/json",
  };
};

const getPublicHeaders = () => ({
  "Content-Type": "application/json",
});

export const digioApi = {
  async doLater(
    data: Pick<
      DigioUploadPayload,
      "userKey" | "loggedInUserKey" | "requestType" | "purpose_code" | "purpose_description"
    >
  ) {
    return await Axios.post("/remit/digio/k2/do-later", data, { headers: getHeaders() });
  },

  async uploadDocument(data: DigioUploadPayload) {
    return await Axios.post("/remit/digio/k2/uploadDocument", data, { headers: getHeaders() });
  },

  async resume(uniqueKey: string, data: DigioUploadPayload) {
    return await Axios.post(`/remit/digio/k2/${uniqueKey}/resume`, data, { headers: getHeaders() });
  },

  async changeSendType(uniqueKey: string, data: DigioUploadPayload) {
    return await Axios.post(`/remit/digio/k2/${uniqueKey}/changeSendType`, data, {
      headers: getHeaders(),
    });
  },

  async getStatus(uniqueKey: string) {
    return await Axios.get(`/remit/digio/k2/${uniqueKey}`, { headers: getPublicHeaders() });
  },

  async refreshAccessToken(uniqueKey: string) {
    return await Axios.post(
      `/remit/digio/k2/${uniqueKey}/access-token`,
      {},
      { headers: getPublicHeaders() }
    );
  },

  async signComplete(uniqueKey: string, data: DigioSignCompletePayload) {
    return await Axios.post(`/remit/digio/k2/${uniqueKey}/signComplete`, data, {
      headers: getPublicHeaders(),
    });
  },

  async downloadDocument(documentId: string) {
    return await Axios.get(`/remit/user/digio/document/download`, {
      params: { document_id: documentId },
      headers: getHeaders(),
      responseType: "blob",
    });
  },

  async resendLink(esignUniqueKey: string) {
    return await Axios.post(
      "/remit/digio/k2/resend-link",
      { esign_unique_key: esignUniqueKey },
      { headers: getHeaders() }
    );
  },
};

export const parseDigioRecord = (response: any): K2DigioRecord | null => {
  const record = response?.data ?? response;
  if (!record || typeof record !== "object") {
    return null;
  }
  return record as K2DigioRecord;
};
